export default __webpack_public_path__ + "static/media/newspaper.e66c0c20.svg";